<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <div class="form-fieldhelp">
      <label>?</label>
      <div class="form-fieldhelp-text">
        <div>Номер мобильного телефона посетителя не{{'\xa0'}}передается в{{'\xa0'}}государственные контролирующие органы</div>
      </div>
    </div>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <phone-input
      :id="inputId"
      :disabled="disabled"
      v-model="inputValue"
      @input="emitValue('input', $event)"
      @change="emitValue('change', $event)"
      @blur="emitValue('blur', $event)"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import PhoneInput from '../../../inputs/PhoneInput.vue'

export default {
  name: 'VisitorPhoneInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin
  ],

  components: {
    PhoneInput
  },

  props: {
    inputLabel: {
      default: 'Мобильный телефон'
    },

    inputName: {
      default: 'phone'
    }
  },

  computed: {
    inputId () {
      let inputId = `form-visitor-phone-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-phone`
      }

      return inputId
    }
  }
}
</script>
